import engineUserAgent from './engine-user-agent.js';

var UA = engineUserAgent;
var engineIsIeOrEdge = /MSIE|Trident/.test(UA);

export { engineIsIeOrEdge as default };
